// Per-route SEO metadata. Update SITE_URL when the production domain is live.
export const SITE_URL = "https://www.saavidigitex.com";
export const BRAND = "Saavi Digitex";

export const SEO = {
  "/": {
    title: "Saavi Digitex · Growth Marketing Agency · Performance, SEO, Content & Lead Generation",
    description:
      "Saavi Digitex is a growth marketing agency helping startups, SMEs and enterprises generate qualified leads through Performance Marketing, SEO, Social Media, Content, Automation and Lead Generation.",
    keywords:
      "digital marketing agency, growth marketing, performance marketing, SEO, lead generation, social media marketing, marketing automation, India digital agency, Saavi Digitex",
  },
  "/about": {
    title: "About · Saavi Digitex — We Build Digital Growth Engines",
    description:
      "Learn how Saavi Digitex helps brands attract, engage, and convert ideal customers — combining creativity, technology, and analytics for measurable ROI.",
    keywords: "about Saavi Digitex, growth agency India, marketing mission, marketing vision",
  },
  "/services": {
    title: "Services · Performance Marketing, SEO, Social, Content & Web · Saavi Digitex",
    description:
      "A complete growth stack — Performance Marketing, SEO, Social Media, Content & Creative, Website Development, Marketing Automation, Analytics and Lead Generation.",
    keywords:
      "performance marketing services, SEO services, social media marketing, content marketing, marketing automation, website development, lead generation services",
  },
  "/industries": {
    title: "Industries We Serve · Education, Healthcare, Real Estate, E-Commerce, Hospitality, Pro Services · Saavi Digitex",
    description:
      "Saavi Digitex delivers growth marketing for Higher Education, Healthcare, Real Estate, E-Commerce, Hospitality and Professional Services brands.",
    keywords:
      "marketing for education, healthcare marketing, real estate marketing, ecommerce marketing, hospitality marketing, professional services marketing",
  },
  "/process": {
    title: "Our Process · The 6-Step Growth Framework · Saavi Digitex",
    description:
      "Our repeatable 6-step Growth Framework: Discovery → Audit → Strategy → Execution → Optimization → Scale. A predictable path from clicks to revenue.",
    keywords: "growth marketing framework, marketing process, lead generation funnel",
  },
  "/case-studies": {
    title: "Case Studies · 300K+ Qualified Leads, 130% Growth, 35% Lower CPL · Saavi Digitex",
    description:
      "Real results across education, business growth and social media campaigns — qualified leads, lower CPL, higher ROAS and community growth from 0 to 100K+.",
    keywords: "marketing case studies, digital marketing results, ROAS improvement, lead generation case study",
  },
  "/packages": {
    title: "Packages · Starter, Business & Scale-Up Growth Plans · Saavi Digitex",
    description:
      "Transparent growth marketing packages — Starter, Business, and Scale-Up plans. Deliverable-based, ROI-focused, dedicated account management.",
    keywords: "marketing packages, growth plans India, digital marketing pricing, marketing retainer",
  },
  "/team": {
    title: "Team · Meet the Experts Behind Your Growth · Saavi Digitex",
    description:
      "Meet the senior team behind Saavi Digitex — Vikas Savant (Founder & Growth Strategist), Junaid Ahmed (Creative Director) and Sarvodya (Media Lead).",
    keywords: "Vikas Savant, Junaid Ahmed, Saavi Digitex team, growth marketing experts",
  },
  "/contact": {
    title: "Contact · Book Your Free Digital Growth Consultation · Saavi Digitex",
    description:
      "Talk to a senior growth strategist. Book a free 30-minute consultation. Call +91 7985005252 or email hello@saavidigitex.com.",
    keywords: "contact Saavi Digitex, book strategy call, marketing consultation, digital marketing audit",
  },
  "/admin": {
    title: "Admin · Saavi Digitex",
    description: "Internal admin dashboard.",
    keywords: "",
    noindex: true,
  },
};

export const ORG_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: BRAND,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  description:
    "Saavi Digitex is a growth marketing agency helping brands generate qualified leads through Performance Marketing, SEO, Social Media, Content, Automation and Lead Generation.",
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+91-7985005252",
      contactType: "customer service",
      email: "hello@saavidigitex.com",
      areaServed: "IN",
      availableLanguage: ["en", "hi"],
    },
  ],
  sameAs: [],
};
